export default {"src":"/_next/static/media/ic_skillz_logo_with_bars.8dd68f4f.svg","height":46,"width":126,"blurWidth":0,"blurHeight":0};